import type {EcommerceSalesChannel} from '@/types/salesChannels';
import type {
  SalesChannel as BolSalesChannel,
  SalesChannelWithStatusDelegationIssued as BolSalesChannelWithStatusDelegationIssued,
} from '@myparcel-frontend/bol-ecommerce-service';
import type {
  SalesChannel as LightspeedSalesChannel,
  SalesChannelWithStatusDelegationIssued as LightspeedSalesChannelWithStatusDelegationIssued,
} from '@myparcel-frontend/lightspeed-ecommerce-service';
import type {
  SalesChannel as PrestaSalesChannel,
  SalesChannelWithStatusDelegationIssued as PrestaSalesChannelWithStatusDelegationIssued,
} from '@myparcel-frontend/presta-ecommerce-service';
import type {
  SalesChannel as ShopifySalesChannel,
  SalesChannelWithStatusDelegationIssued as ShopifySalesChannelWithStatusDelegationIssued,
} from '@myparcel-frontend/shopify-ecommerce-service';
import type {
  SalesChannel as WooSalesChannel,
  SalesChannelWithStatusDelegationIssued as WooSalesChannelWithStatusDelegationIssued,
} from '@myparcel-frontend/woo-ecommerce-service';

export const isSalesChannelWithStatusDelegationIssued = (
  channel: BolSalesChannel | PrestaSalesChannel | WooSalesChannel | ShopifySalesChannel | LightspeedSalesChannel,
): channel is
  | BolSalesChannelWithStatusDelegationIssued
  | PrestaSalesChannelWithStatusDelegationIssued
  | WooSalesChannelWithStatusDelegationIssued
  | ShopifySalesChannelWithStatusDelegationIssued
  | LightspeedSalesChannelWithStatusDelegationIssued => {
  return channel.status === 'DELEGATION_ISSUED';
};

export const isSalesChannelWithStatusDelegationRequested = (channel: EcommerceSalesChannel): boolean => {
  return channel.status === 'DELEGATION_REQUESTED';
};

export const isSalesChannelWithStatusDelegationRequired = (channel: EcommerceSalesChannel): boolean => {
  return channel.status === 'DELEGATION_REQUIRED';
};
